export function buildMaterialSummary(project, layout) {
  const activePartCount = project.projects.reduce(
    (total, subproject) => total + subproject.panels
      .filter((panel) => !panel.hidden)
      .reduce((sum, panel) => sum + Math.max(Number(panel.quantity) || 0, 0), 0),
    0,
  );
  const newSheetCount = layout.metrics.newSheetCount ?? layout.metrics.sheetCount;
  const restSheetCount = layout.metrics.restSheetCount ?? 0;

  return {
    projectName: project.projectName,
    materialName: project.materialName,
    sourcePanel: project.sourcePanel,
    metrics: {
      ...layout.metrics,
      newSheetCount,
      restSheetCount,
    },
    breakdown: layout.breakdown,
    invalidCount: layout.invalid.length,
    activePartCount,
    restStockCount: (project.restStock || []).length,
    projects: project.projects.map((subproject) => ({
      id: subproject.id,
      name: subproject.name,
      color: subproject.color,
      partCount: subproject.panels
        .filter((panel) => !panel.hidden)
        .reduce((sum, panel) => sum + Math.max(Number(panel.quantity) || 0, 0), 0),
    })),
  };
}
